﻿import {$, $$} from "@/Utils"
import {ToggleBehaviour} from "@/enums";

/**
 * Avame/sulgeme kliendi soovil erinevaid akordione või lihtsalt lehe osi

 * @param elem - Elemendiks on ühe sisu konteiner, mida avatakse/suletakse
 * @param toggleClass - CSS-klass, mis juhib elementide nähtavust
 * @param toggleBehaviour - juhib kuidas peame naaberelementidega käituma
 */
function executeToggleClick(e: Event, elem: Element, toggleClass: string, toggleBehaviour: ToggleBehaviour) {
    if(!document.getSelection().isCollapsed) return; // Deselect still triggers early-exit, but cannot distinguish
    // TODO: <label><input type=checkbox></label>, kus handler on labeli peal, tekitab topelt-event'e.
    // Järgnev kood peidab vaid ToggleBehaviour.Radio puhul selle vea
    e.stopPropagation();
    const wasOpen = elem.classList.contains(toggleClass);
    if (wasOpen && toggleBehaviour === ToggleBehaviour.Open) {
        return;
    }
    if (toggleBehaviour === ToggleBehaviour.Single || toggleBehaviour === ToggleBehaviour.Radio) {
        elem.parentElement.querySelector(`.${toggleClass}`)?.classList.remove(toggleClass);
        if (wasOpen && toggleBehaviour === ToggleBehaviour.Single) {
            return;
        }
    }

    elem.classList.toggle(toggleClass);
}

/**
 * target-closest - klassi järgi leitav element asub kliki saanud elemendist kõrgemal
 */
export function bindToggleByClass() {
    $$(".accordion__title, [data-toggle-radio], [data-toggle-target-closest]").forEach(x => {
        if (x.getAttribute("data-toggle-target-bound")) {
            return;
        }
        x.setAttribute("data-toggle-target-bound", "true");
        const target = x.getAttribute("data-toggle-target-closest") || "accordion__item";
        const toggleClass = x.getAttribute("data-toggle-class") || target + "--active";
        const toggleBehaviour = x.hasAttribute("data-toggle-single") ? ToggleBehaviour.Single : (x.hasAttribute("data-toggle-radio") ? ToggleBehaviour.Radio : x.hasAttribute("data-toggle-open") ? ToggleBehaviour.Open : ToggleBehaviour.Free);
        const closest = x.closest(`.${target}`) || x;
        x.addEventListener("click", (e: Event) => executeToggleClick(e, closest, toggleClass, toggleBehaviour));
    });
    $$("[data-toggle-this]").forEach(x => {
        if (x.getAttribute("data-toggle-target-bound")) {
            return;
        }
        x.setAttribute("data-toggle-target-bound", "true");
        const toggleClass = x.getAttribute("data-toggle-this");
        x.addEventListener("click", (e: Event) => executeToggleClick(e, x, toggleClass, ToggleBehaviour.Free));
    });
}

/**
 * Toob elemendi vaatesse ja avab selle
 * DevExpress-i piirangu tõttu ei kasuta me siin data-atribuute
 */
export function bindScrollAndOpen() {
    $$(".scroll-and-open").forEach((x: HTMLAnchorElement) => {
        if (!x || x.hasAttribute("data-bound")) {
            return;
        }
        x.setAttribute("data-bound", "true");
        const target = $(x.getAttribute("href"));
        const toggleClass = x.getAttribute("data-toggle-class") || "accordion__item--active";
        x.addEventListener("click", (e: Event) => {
            e.preventDefault();
            executeToggleClick(e, target, toggleClass, ToggleBehaviour.Open);
            window.scrollTo({
                top: target.offsetTop,
                behavior: 'smooth'
            });
        });
    });
}